import DOMPurify from 'dompurify'
import { marked } from 'marked'
import React, { useEffect, useState } from 'react'

interface MarkdownComponentProps {
  children: string
}

const MarkdownComponent: React.FC<MarkdownComponentProps> = ({ children }) => {
  const [sanitizedHtml, setSanitizedHtml] = useState<string>('')

  useEffect(() => {
    const processMarkdown = async () => {
      const htmlContent = await marked(children || '')
      // Medien-Tags laden ihre Quelle automatisch nach — bei KI-generiertem
      // Markdown ein Exfiltrationskanal (z.B. ![](https://…?daten=…)).
      // Kein Konsument rendert legitim Bilder, daher pauschal verboten.
      const sanitized = DOMPurify.sanitize(htmlContent, {
        FORBID_TAGS: ['img', 'picture', 'source', 'video', 'audio', 'track']
      })
      setSanitizedHtml(sanitized)
    }

    processMarkdown()
  }, [children])

  return <div dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
}

export default MarkdownComponent
